import { render, staticRenderFns } from "./AppUpdater.vue?vue&type=template&id=236f04a6&scoped=true&"
import script from "./AppUpdater.vue?vue&type=script&lang=js&"
export * from "./AppUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236f04a6",
  null
  
)

export default component.exports